import { ApiService, Model } from '@kaiser-software/chassis-core';

export class TaxModel extends Model {

    public id: number;
    public code: string;
    public name: string;
    public rate: number;
    public default: boolean;

    /**
     * Constructor.
     */
    public constructor(data?: Object, service?: ApiService) {
        super(data, service);

        this.boot(data);
    }

}




// WEBPACK FOOTER //
// ./libs/donna-core/src/app/tax/models/tax.model.ts